const test: string = 'Hello world';

console.log(test);
